import { render, staticRenderFns } from "./StageCard.vue?vue&type=template&id=7073f216&scoped=true&"
import script from "./StageCard.vue?vue&type=script&lang=js&"
export * from "./StageCard.vue?vue&type=script&lang=js&"
import style0 from "./StageCard.vue?vue&type=style&index=0&id=7073f216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073f216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VIcon})
